/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

require('frontend/assets/js/lib/performance.js');

}.call(window));